import React, { useState, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";

import PropTypes from "prop-types";
import CustomerRow from "./Row.jsx";
import Sorter from "./Sorter.jsx";
import PageSelector from "./PageSelector";
import Actions from "../../../store/actions/customerActions";

function CustomerTable({ customers }) {
	const dispatch = useDispatch();
	const [activeSorter, setActiveSorter] = useState({
		field: `firstName`,
		order: `asc`
	});
	const [page, selectPage] = useState(0);

	const numberOfRecordsToShow = 10;
	const customersToShow = useMemo(() => {
		function getCustomersToShow() {
			const startingIndex = page * numberOfRecordsToShow;
			return customers.slice(startingIndex, startingIndex + numberOfRecordsToShow);
		}

		return getCustomersToShow();
	}, [customers, page]);

	useEffect(() => {
		dispatch(Actions.sort(activeSorter.field, activeSorter.order));
	}, [activeSorter.field, activeSorter.order, dispatch]);

	function selectActiveSorter(field, order) {
		setActiveSorter({ field, order });
	}
	return (
		<>
			<PageSelector
				page={page}
				lengthOfArray={customers.length}
				stepLength={numberOfRecordsToShow}
				selectPage={selectPage}
			/>
			<table className="table table-bordered">
				<thead>
					<tr>
						<th>
							First name{` `}
							<Sorter field={`firstName`} activeSorter={activeSorter} sortBy={selectActiveSorter} />
						</th>
						<th>
							Last name{` `}
							<Sorter field={`lastName`} activeSorter={activeSorter} sortBy={selectActiveSorter} />
						</th>
						<th>
							Email{` `}
							<Sorter field={`email`} activeSorter={activeSorter} sortBy={selectActiveSorter} />
						</th>
						<th>
							Toyota ID{` `}
							<Sorter field={`toyotaID`} activeSorter={activeSorter} sortBy={selectActiveSorter} />
						</th>
						<th className="text-right">Options</th>
					</tr>
				</thead>
				<tbody>
					{customersToShow &&
						customersToShow.map(customer => {
							return <CustomerRow key={customer.uuid} customer={customer} />;
						})}
				</tbody>
			</table>
		</>
	);
}

CustomerTable.propTypes = {
	customers: PropTypes.array
};

export default CustomerTable;
